<template>
  <div></div>
</template>
<script>
  import {updateToken} from '@/data/api/auth'

  export default {
    created() {
      const sso = {
        userId: this.$route.query.user_id,
        sessionId: this.$route.query.session_id,
      }
      this.$store.commit('setSSO', sso)
      updateToken(sso)
      this.$router.push({path: String(this.$route.query.returnUrl)})
    },
  }
</script>
